import { useEffect, useState } from 'react';
import { BsArrowLeft } from 'react-icons/bs';
import { useMaintenanceDeviceContext } from '../../contexts/MaintenanceDeviceProvider/MaintenanceDeviceProvider';
import WidgetLoadingAnimation from 'components/Widgets/WidgetLoadingAnimation';
import { getDeviceMaintenanceUrls } from 'services/devices/devices.service';
import { Button } from 'react-bootstrap';

const MaintenanceIFrame = () => {
  const { selectedDevice, setSelectedDevice } = useMaintenanceDeviceContext();

  const [url, setUrl] = useState();
  const [error, setError] = useState(null);

  useEffect(() => {
    getUrl();
  }, [selectedDevice]);

  const getUrl = async () => {
    const newUrl = await getDeviceMaintenanceUrls(selectedDevice);

    if (!newUrl) setError('Failed to load maintenance window.');

    setUrl(newUrl);
  };

  const clearSelectedDevice = () => setSelectedDevice(null);

  if (!url && !error) return <WidgetLoadingAnimation />;

  return (
    <div className="d-flex flex-column">
      <Button
        className="d-flex gap-3 align-items-center w-fit bg-transparent btn-transparent"
        onClick={clearSelectedDevice}
      >
        <BsArrowLeft size={20} />
        <p className="mb-0">Back</p>
      </Button>

      {error && <p data-error>{error}</p>}
      {!error && (
        <div className="d-flex w-100">
          <iframe src="https://www.rescalert.com" title="Device Maintenance Window 1" />
          <iframe src={url?.tb_url} title="Device Maintenance Window 2" />
        </div>
      )}
    </div>
  );
};

export default MaintenanceIFrame;
